var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833333,
    y: 0.833333,
    width: 28.3333,
    height: 28.3333,
    rx: 14.1667,
    fill: "white",
    stroke: "#E2E2E2",
    strokeWidth: 1.66667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2401 10.2459C20.0838 10.0897 19.8719 10.002 19.6509 10.002C19.4299 10.002 19.218 10.0897 19.0618 10.2459L15.2401 14.0676L11.4184 10.2459C11.2621 10.0897 11.0502 10.002 10.8292 10.002C10.6083 10.002 10.3964 10.0897 10.2401 10.2459C10.0839 10.4022 9.99609 10.6141 9.99609 10.8351C9.99609 11.0561 10.0839 11.268 10.2401 11.4243L14.0617 15.2459L10.2401 19.0676C10.0839 19.2239 9.99609 19.4358 9.99609 19.6568C9.99609 19.8777 10.0839 20.0897 10.2401 20.2459C10.3964 20.4022 10.6083 20.4899 10.8292 20.4899C11.0502 20.4899 11.2621 20.4022 11.4184 20.2459L15.2401 16.4243L19.0618 20.2459C19.218 20.4022 19.4299 20.4899 19.6509 20.4899C19.8719 20.4899 20.0838 20.4022 20.2401 20.2459C20.3963 20.0897 20.4841 19.8777 20.4841 19.6568C20.4841 19.4358 20.3963 19.2239 20.2401 19.0676L16.4184 15.2459L20.2401 11.4243C20.3963 11.268 20.4841 11.0561 20.4841 10.8351C20.4841 10.6141 20.3963 10.4022 20.2401 10.2459Z",
    fill: "#1C1F37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCross);
export default __webpack_public_path__ + "static/media/modal-cross.9676685acadb2718c4385cd90f113090.svg";
export { ForwardRef as ReactComponent };